'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _light = require('./light');

var _light2 = _interopRequireDefault(_light);

var _medium = require('./medium');

var _medium2 = _interopRequireDefault(_medium);

var _long = require('./long');

var _long2 = _interopRequireDefault(_long);

var _fontAwesome = require('./fontAwesome');

var _fontAwesome2 = _interopRequireDefault(_fontAwesome);

var _move = require('./move');

var _move2 = _interopRequireDefault(_move);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  light: _light2.default,
  medium: _medium2.default,
  long: _long2.default,
  fontAwesome: _fontAwesome2.default,
  move: _move2.default
}; /*
    * Exports
    */


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/Arrows/index.js
// module id = 135
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16